// CORE
import * as React from 'react';
import { useCallback } from 'react';
import { useTimeoutFn } from 'react-use';

// MUI
import Box from '@mui/material/Box';

import { rootUiActions } from 'app-components/flux/root-ui';
import ThumbsUpIcon from 'assets/illustrations/Thumbs-up-star.png';
// SHARED/LOCAL
import ZeroStateView from 'components/ZeroStateView';
import { useDispatch } from 'react-redux';

// @ts-expect-error FIXME TS7006
const GoalDone = (_props) => {
  const dispatch = useDispatch();

  const handleClose = useCallback(() => {
    dispatch(rootUiActions.removeDialog());
  }, [dispatch]);

  useTimeoutFn(handleClose, 1000);

  return (
    <Box width={'600px'} height={'400px'} margin={'auto'} justifySelf={'center'} alignSelf={'center'}>
      <ZeroStateView icon={ThumbsUpIcon} primary={'Your goal has been created!'} />
    </Box>
  );
};

export default GoalDone;
